import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React from "react";
import { invoiceExpenseGroupingReportGroupingOptions } from "../../../../../clients/inventoryObjects";

const toggleButtonStyle = {
  borderTopRightRadius: "8px !important",
  borderBottomRightRadius: "8px !important",
  borderTopLeftRadius: "8px !important",
  borderBottomLeftRadius: "8px !important",
  border: "none",
  backgroundColor: (theme) => theme.palette.terrain[200],
  "&.Mui-selected, &.Mui-selected:hover": {
    color: (theme) => theme.palette.pure.white,
    backgroundColor: (theme) => theme.palette.terrain[900],
  },
};

const ShowOptions = ({ reportGroupingChoice, setReportGroupingChoice }) => {
  const handleSelect = (_, v) => {
    if (v === null) {
      return;
    }
    setReportGroupingChoice(v);
  };

  return (
    <Box>
      <Box>
        <Typography variant="h5">Show</Typography>
      </Box>
      <Box sx={{ marginTop: 2 }}>
        <ToggleButtonGroup
          value={reportGroupingChoice}
          onChange={handleSelect}
          exclusive
        >
          <ToggleButton
            value={
              invoiceExpenseGroupingReportGroupingOptions.expenseGroupsOnly
            }
            sx={[
              toggleButtonStyle,
              {
                marginRight: 2,
              },
            ]}
          >
            <Typography sx={{ textTransform: "none" }} variant="subtitle1">
              Expense Groups Only
            </Typography>
          </ToggleButton>
          <ToggleButton
            value={
              invoiceExpenseGroupingReportGroupingOptions.expenseSubgroupsOnly
            }
            sx={[
              toggleButtonStyle,
              {
                marginRight: 2,
              },
            ]}
          >
            <Typography sx={{ textTransform: "none" }} variant="subtitle1">
              Expense Subgroups Only
            </Typography>
          </ToggleButton>
          <ToggleButton
            value={invoiceExpenseGroupingReportGroupingOptions.both}
            sx={[
              toggleButtonStyle,
              {
                marginRight: 2,
              },
            ]}
          >
            <Typography sx={{ textTransform: "none" }} variant="subtitle1">
              Both
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default ShowOptions;
